// extracted by mini-css-extract-plugin
export var dropdownButton = "_3i-0";
export var fullWidthDropdownButton = "_3i-1";
export var icon = "_3i-3";
export var iconPlaceholder = "_3i-2";
export var menuItemRow = "_3i-8";
export var separator = "_3i-c";
export var shortcutContainer = "_3i-7";
export var shortcutIconLg = "_3i-6";
export var shortcutIconMd = "_3i-5";
export var shortcutIconSm = "_3i-4";
export var submenuChevron = "_3i-b";
export var submenuDropdown = "_3i-9";
export var submenuTriggerRow = "_3i-a";